import React from 'react';
import { GridPattern } from '../common/GridPattern';
import { CartesianAxes } from '../common/CartesianAxes';
import { DraggablePoint } from '../common/DraggablePoint';

export const TriangleComponent = ({ params, showCoords, onPointDrag, svgRef, viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const { pointA_x, pointA_y, pointB_x, pointB_y, pointC_x, pointC_y, fill = "lightblue", stroke = "blue", strokeWidth = 2 } = params;
  
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const viewBox = `0 0 ${scaledWidth} ${scaledHeight}`;
  const displayHeight = Math.max(200, Math.min(800, viewportHeight * viewportScale));
  
  return (
    <svg ref={svgRef} viewBox={viewBox} className="w-full border border-gray-300" style={{ height: `${displayHeight}px` }}>
      <GridPattern viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
      
      <polygon
        points={`${pointA_x},${pointA_y} ${pointB_x},${pointB_y} ${pointC_x},${pointC_y}`}
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      
      {showCoords && (
        <>
          <DraggablePoint 
            cx={pointA_x} cy={pointA_y} 
            label="A" coords={`(${pointA_x},${pointA_y})`}
            onDrag={(x, y) => onPointDrag('pointA_x', x, 'pointA_y', y)}
            svgRef={svgRef}
          />
          <DraggablePoint 
            cx={pointB_x} cy={pointB_y} 
            label="B" coords={`(${pointB_x},${pointB_y})`}
            onDrag={(x, y) => onPointDrag('pointB_x', x, 'pointB_y', y)}
            svgRef={svgRef}
          />
          <DraggablePoint 
            cx={pointC_x} cy={pointC_y} 
            label="C" coords={`(${pointC_x},${pointC_y})`}
            onDrag={(x, y) => onPointDrag('pointC_x', x, 'pointC_y', y)}
            svgRef={svgRef}
          />
        </>
      )}
      
      <CartesianAxes viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
    </svg>
  );
};

